<template>
  <!-- Footer -->
  <footer class="py-5 bg-dark " >
    <div class="container">
      <p class="m-0 text-center text-white">Copyright &copy; Uploader 2018</p>
    </div>
    <!-- /.container -->
  </footer>
</template>

<script>
    export default {
        name: "Footer"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Footer.vue